
import DATA from "../data/_clients.json";

import "./reviews.css"

const Reviews = () => {
   return (
      <>

         <h2>&nbsp;Clients - Reviews</h2>
         {DATA.clients.reviews ?
            <div className="framer">
               <ul className="columnar">
                  {DATA.clients.reviews.map((rv) => {
                     return (
                        <div key={rv[0]} className="col-sm-12 col-md-12">
                           <li className="review">
                              {rv[2] ?
                                 <img src={rv[2]} title={rv[2]} alt="img" className="review-img"></img>
                                 : null
                              }
                              {rv[0]}
                              <div className="review-author">
                                 - {rv[1]}<small> ({rv[3]})</small>
                              </div>
                           </li>
                        </div>
                     )
                  })}
               </ul>
            </div >
            : null}
      </>
   )
}

export default Reviews;
